<div class="card__info card__info--primary">
  @if (availableBalance.intValue > 0) {
    <span class="card__info__title">{{
      'dashboard-advance-block.component.available_title'
        | localise: 'Available'
    }}</span>
    <span class="card__info__subtext">
      {{
        'dashboard-advance-block.component.calendar_event_type_closing_text'
          | localise: 'Add a new deal to increase your limit.'
      }}
    </span>
    <span class="card__info__amount">{{
      availableBalance | currencyJs: { showSymbol: true }
    }}</span>
    <mat-progress-bar
      mode="determinate"
      [value]="percentageUsed"></mat-progress-bar>
    <span class="mat-progress-bar-labels">
      <span>0</span>
      <span>{{ limit | currencyJs: { showSymbol: true } }}</span>
    </span>
  }

  @if (availableBalance.intValue === 0) {
    <div class="card__info__zero-state">
      <img src="../../../../../assets/img/icons/dollar-card-pencil.svg" />
      <div>
        {{
          'dashboard-advance-block.component.add_deal_apply_for_commission_advance'
            | localise: 'Add a deal to apply for a commission advance.'
        }}
      </div>
    </div>
  }

  <div class="card__info__actions">
    @if (!productPayment) {
      <button mat-flat-button class="action-button" (click)="addDeal.emit()">
        {{
          'dashboard-advance-block.component.add_deal_button'
            | localise: 'Add a Deal'
        }}
      </button>
    }
    @if (productPayment) {
      <button
        mat-flat-button
        class="action-button"
        (click)="openConfirmModal()">
        {{
          'dashboard-advance-block.component.add_deal_button'
            | localise: 'Add a Deal'
        }}
      </button>
    }
    @if (availableBalance.intValue > 0) {
      <button
        mat-flat-button
        class="action-button action-button--primary"
        (click)="transferMoney.emit()">
        {{
          'dashboard-advance-block.component.transfer_money_button'
            | localise: 'Transfer Money'
        }}
      </button>
    }
  </div>
</div>

<ng-template #confirmAddDeal>
  <div class="dashboard__body">
    <div mat-dialog-title class="header-text">
      {{
        'dashboard-advance-block.component.you_sure_want_add_deal'
          | localise: 'Are you sure you want to add a deal?'
      }}
    </div>
    <div mat-dialog-content class="type-description">
      {{
        'dashboard-advance-block.component.adding_deal_you_requesting_commission'
          | localise
            : "By adding a deal, you will be requesting a commission-backed line of credit which gives you access to a pending commission before closing. If you're expecting a commission payment from your broker, you do not need to add a deal."
      }}
    </div>
    <div class="display-flex">
      <button mat-dialog-close mat-button type="button">
        {{ 'dashboard-advance-block.component.close' | localise: 'Close' }}
      </button>
      <button
        mat-flat-button
        mat-dialog-close
        class="action-button action-button--primary"
        (click)="addDeal.emit()">
        {{
          'dashboard-advance-block.component.continue' | localise: 'Continue'
        }}
      </button>
    </div>
  </div>
</ng-template>
